module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_6005.f1ba53f4.png";